var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isPc)?_c('div',{staticClass:"pc"},[(_vm.isReload)?_c('router-view'):_vm._e()],1):_vm._e(),(_vm.isMobil)?_c('div',{staticClass:"mob"},[(_vm.isReload)?_c('router-view'):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }